<script setup lang="ts">
  import type { PropType } from 'vue';
  import { DocumentType } from '@storefront/types';

  defineOptions({
    inheritAttrs: false,
  });

  type OrderDocument = {
    id: number;
    type: DocumentType;
    reference_number: string;
    download: string;
  }

  defineProps({
    order: { type: Object, required: true },
    repayment: { type: String, required: false },
    complaint: { type: String, required: false },
    refund: { type: String, required: false },
    reorder: { type: String, required: false },
    documents: { type: Array as PropType<OrderDocument[]>, required: false, default: [] },
    packages: { type: Array, required: false, default: [] },
    shipments: { type: Array, required: false, default: [] },
  });
</script>
<template>
  <main id="main" class="order">
    <OrderDetailsView v-bind="$props" />
  </main>

  <RouterView />
</template>
